export default __webpack_public_path__ + "static/media/img_loading.79e7145f.png";